import {PRIOR_AUTH_DEFAULT_CLINIC_ID} from '../actions/Index';

const initState = {
  priorAuthDefaultClinicId: null,
  priorAuthDefaultFilters: null
};
export default function (state = initState, action: any): any {
  const {type, payload} = action;
  switch (type) {
    case PRIOR_AUTH_DEFAULT_CLINIC_ID:
      return {
        ...state,
        priorAuthDefaultClinicId: payload.priorAuthDefaultClinicId,
        priorAuthDefaultFilters: payload.priorAuthDefaultFilters
      };
    default:
      return state;
  }
}
